<div [formGroup]="form" class="flex flex-col items-stretch mt-0 mr-0 ml-0">
	<div class="mb-3 flex flex-col items-stretch mt-0 mr-0 ml-0">
		<label>
			{{
				'presentation.app.sidebar.coachees.addCoachee.existingCoachee.coachees.label'
					| translate
			}}
		</label>
		<p-dropdown
			[options]="coacheesWithoutCoach$ | async"
			[style]="{ width: '100%' }"
			appendTo="body"
			formControlName="coacheeId"
		></p-dropdown>
	</div>
	<button
		[disabled]="!(formValid$ | async)"
		[label]="
			'presentation.app.sidebar.coachees.addCoachee.existingCoachee.add.label'
				| translate
		"
		(click)="onAddClick()"
		pButton
	></button>
</div>
